// extracted by mini-css-extract-plugin
export var chip = "_f9-0";
export var filterDropdown = "_f9-5";
export var filterItem = "_f9-6";
export var icon = "_f9-1";
export var removeButton = "_f9-3";
export var removeIcon = "_f9-4";
export var separator = "_f9-2";